/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/media-has-caption */
// @flow
import * as React from 'react';
// import classNames from 'classnames';
import * as css from './MainContent.scss';

type Props = {|
	source: string,
	playerType: string,
|};

type State = {};

class VideoFrame extends React.PureComponent<Props, State> {
	// videoRef: { current: null | HTMLVideoElement } = React.createRef();

	state = {};

	componentDidMount() {}

	componentDidUpdate(prevProps: Props) {}

	renderFrame = () => {
		const { source, playerType } = this.props;

		if (playerType === '1') {
			const src = `${source}?autoplay=1`;
			return (
				<iframe title="title" src={src} frameBorder="0" className={css.youTubeIframe} allow="autoplay"></iframe>
			);
		}

		if (playerType === '2') {
			const src = `${source}?autoplay=1`;
			return (
				<iframe
					title="title"
					src={src}
					width="100%"
					height="100%"
					frameBorder="0"
					className={css.vimeoIframe}
					allow="autoplay"
				></iframe>
			);
		}

		if (playerType === '3') {
			return <video className={css.htmlVideo} src={source} autoPlay playsInline controls></video>;
		}
	};

	render() {
		return <>{this.renderFrame()}</>;
	}
}

export default VideoFrame;
